<template>
  <div id="app" @click="h5headerHideFn">
    <headers ref="head"></headers>
    <router-view class="app-content" />
    <footers></footers>
  </div>
</template>

<script>
import headers from "./components/header.vue";
import footers from "./components/footer.vue";
import en from "./utils/en.js";
import zh from "./utils/zh.js";
export default {
  name: "App",
  data() {
    return {
      // ennav: ennavList,
      // navList: navList,
    }
  },
  components: {
    headers,
    footers,
  },
  methods: {
    h5headerHideFn() {
      this.$refs.head.twoShow = false;
      console.log(this.$refs.head.twoShow)
      console.log(zh.navList)
      zh.navList.filter(item => item.show = false)
      en.navList.filter(item => item.show = false)
      // 设置i18n 里的navList里的字段show=false;

      // this.$children.h5show = false;
    },
  },
};
</script>

<style>
.people .el-carousel__arrow--left,
.people .el-carousel__arrow--right {
  top: 30%;
}

.index-swiper .el-carousel__arrow--left,
.index-swiper .el-carousel__arrow--right {
  top: 70%;
}

.cup {
  cursor: pointer;
}

.big-title {
  color: #0a9a7a;
  text-align: center;
  line-height: 40px;
  font-weight: 600;
  margin-bottom: 70px;
  margin-top: 50px;
  position: relative;
}

.big-title span {
  position: relative;
  font-size: 24px;
}

.big-title span::after {
  content: "";
  bottom: -10px;
  left: 10px;
  height: 4px;
  right: 10px;
  text-align: center;
  background: #0a9a7a;
  position: absolute;
}

.reg-table .el-table--border td,
.reg-table .el-table--border th,
.reg-table .el-table__body-wrapper .el-table--border.is-scrolling-left~.el-table__fixed,
.reg-table .el-table--border,
.reg-table .el-table--group {
  border-color: #999 !important;
}

.reg-table .el-table--border {
  border-right: 1px solid #999;
  border-bottom: 1px solid #999;
}

.reg-table .el-table thead {
  color: #333;
}

* {
  margin: 0;
  padding: 0;
  list-style: none;
  text-decoration: none;
  font-size: 14px;
  font-family: "Hiragino Sans GB", "Microsoft Yahei UI", "Microsoft Yahei",
    "微软雅黑", "Segoe UI", Tahoma, "宋体b8b\4f53", SimSun, sans-serif;
}

#app,
html,
body {
  width: 100%;
  height: 100%;
}

:deep(.el-button--primary) {
  background: #0a9a7a;
}

.u-line-1 {
  word-break: break-all;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  overflow: hidden;
}

.u-line-2 {
  word-break: break-all;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
}

.u-line-3 {
  word-break: break-all;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
  overflow: hidden;
}

@media screen and (max-width: 768px) {

  .people-lists-contents.el-carousel--horizontal,
  .people-lists-contents .el-carousel__container {
    height: 730px;
  }

  .index-swiper .el-carousel__container {
    height: 120px;
  }
}
</style>


// WEBPACK FOOTER //
// src/App.vue